// TODO - REMOVE THIS COMPONENT AND IT'S STYLESHEET ONCE VIDEO-SERIES PAGES ARE FULLY IMPLEMENTED

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router';
import { initialState } from 'store/reducers/search';
import { defaultVideoFilters } from 'store/actions/videos';
import { setQuery, search, updateFilter, resetSessionFilters } from 'store/actions/search';
import { clearSavedSearchError } from 'store/actions/savedsearch';
import { autocomplete } from 'store/actions/autocomplete';
import SearchInput from 'components/elements/common/forms/searchinput/SearchInput';
import SearchGoButton from 'components/elements/common/forms/searchgobutton/SearchGoButton';
import NewSavedSearchModal from 'components/elements/common/modal/savedsearch/NewSavedSearchModal';
import PermissionButton from 'elements/common/permission/PermissionButton';
import { SEARCH_ROUTE } from '../../../../../routes';
import Dropdown from '../../common/dropdown/Dropdown';
import { ASSET_TYPES, SEARCH_CONTEXTS } from '../../../utils/constants';

import './LegacySearchBar.scss';

class LegacySearchBar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      query: '',
      newSavedSearchOpen: false,
    };
    const { topics, companies, people, series } = SEARCH_CONTEXTS;
    this.defaultContexts = `${topics.autocomplete},${companies.autocomplete},${people.autocomplete}`;
    this.allContexts = `${this.defaultContexts},${series.autocomplete}`;
  }

  handleSearchChange(evt, query) {
    this.setState({ query });
  }

  handleSubmit(evt) {
    this.props.resetSessionFilters();
    if (evt.preventDefault) {
      // user hit enter without using an autocomplete query
      evt.preventDefault();
      this.props.setQuery(this.state.query);
    } else {
      // user selected an autocomplete query
      const { context, value, displayValue } = evt;
      this.props.updateFilter(context.toLowerCase(), value, { value, displayValue });
    }
    this.setState({ query: '' });
    this.props.search();

    const { location: { pathname }, history } = this.props;
    if (pathname !== SEARCH_ROUTE) {
      history.push(SEARCH_ROUTE);
    }
  }

  handleDropdownFilterClick(filterName) {
    const mediaFilters = Object.keys(initialState.filters.media);
    mediaFilters.map(filter => this.props.updateFilter('media', filter, (filterName === filter)));
    this.handleGoButtonClick(null, filterName === ASSET_TYPES.video.type);
  }

  handleGoButtonClick(query, handleVideo) {
    this.props.resetSessionFilters();
    if (handleVideo) {
      this.props.defaultVideoFilters();
    }
    this.props.setQuery(query || '');
    this.setState({ query: '' });
    this.props.search();
  }

  openNewSavedSearchModal() {
    this.setState({ newSavedSearchOpen: true });
  }

  closeNewSavedSearchModal() {
    this.setState({ newSavedSearchOpen: false });
    this.props.clearSavedSearchError();
  }

  render() {
    const { filters: { media: { video } }, loading, hasResults, location: { pathname } } = this.props;
    const { query } = this.state;

    const FEATURE_VIDEO_ENABLED = JSON.parse(process.env.FEATURE_VIDEO_ENABLED || false);
    const showSaveSearchButton = hasResults && pathname === SEARCH_ROUTE;
    const autocompleteContexts = video ? this.allContexts : this.defaultContexts;
    return (
      <React.Fragment>
        <Dropdown className="legacy-searchbar--select-dropdown dark-theme" title={'Recent'} closeOnClick>
          <ul>
            <Link to='/search' onClick={() => this.handleDropdownFilterClick('text')}><li>News</li></Link>
            <Link to='/search' onClick={() => this.handleDropdownFilterClick('photo')}><li>Photos</li></Link>
            { FEATURE_VIDEO_ENABLED && <Link to='/search' onClick={() => this.handleDropdownFilterClick('video')}><li>Videos</li></Link> }
          </ul>
        </Dropdown>

        <Link to='/search' onClick={() => this.handleGoButtonClick(query, true)}><SearchGoButton /></Link>

        <SearchInput
          className={`legacy-searchbar ${showSaveSearchButton ? 'showing-button' : ''}`.trim()}
          autocomplete={true}
          autocompleteId={'search-input-autocomplete'}
          autocompleteContexts={autocompleteContexts}
          value={query}
          getSuggestions={this.props.autocomplete}
          handleSubmit={evt => this.handleSubmit(evt)}
          onChange={(evt, newValue) => this.handleSearchChange(evt, newValue)}
          disabled={loading}>
          {showSaveSearchButton && <PermissionButton permission="savesearch" className="legacy-searchbar-save" onClick={() => this.openNewSavedSearchModal()} ariaLabel="add saved search" />}
        </SearchInput>

        <NewSavedSearchModal
          open={this.state.newSavedSearchOpen}
          handleClose={() => this.closeNewSavedSearchModal()}
          afterSave={() => this.closeNewSavedSearchModal()}
          timeout={1000}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ search: searchStore }) => ({
  loading: searchStore.loading,
  query: searchStore.query,
  filters: searchStore.filters,
  hasResults: !!searchStore.results.length,
});

const mapDispatchToProps = {
  setQuery,
  updateFilter,
  search,
  autocomplete,
  clearSavedSearchError,
  resetSessionFilters,
  defaultVideoFilters,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LegacySearchBar));
